import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

function DynamicIndexRedirect() {
  const { user, isAuthenticated, token, isLoading } = useSelector(
    (state) => state.auth,
  );
  const hasStoredToken = Boolean(sessionStorage.getItem("authToken"));

  // If a token exists and validation is in progress, wait.
  if (hasStoredToken && !isAuthenticated && isLoading) return null;

  if (!isAuthenticated || !token || !user)
    return <Navigate to="/login" replace />;
  const dashboardPath = user.isAdmin ? "AdminDashboard" : "EmployeeDashboard";
  return <Navigate to={dashboardPath} replace />;
}

export default DynamicIndexRedirect;
